import { createFeature, createReducer } from '@ngrx/store';

// Simple state interface for data readiness
export interface DataReadinessState {
  // Add your data readiness state properties here
  // For now, keeping it simple
}

// Initial state
export const initialState: DataReadinessState = {
  // Initialize your state properties here
};

// Feature with automatic selector generation
export const dataReadinessFeature = createFeature({
  name: 'dataReadiness',
  reducer: createReducer(initialState)
});

// Export reducer for store config
export const dataReadinessReducer = dataReadinessFeature.reducer;
